import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY } from "../../config/Config";
 
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY,
    extensions: [reactPlugin],
    disableCookiesUsage: true,
    isStorageUseDisabled: true,
    enableSessionStorageBuffer: false
  },
});

appInsights.loadAppInsights();

export const trackEvent = (eventPath, message) => {
  appInsights.appInsights.trackEvent({
    name: "Client Side - " + eventPath + " - " + message,
  });
};

export const trackException = (exceptionPath, exception) => {
  appInsights.appInsights.trackException({
    exception: new Error(
      "Client Side - " + exceptionPath + " - " + exception
    ),
  });
};

export {reactPlugin}
